import React, { useState, useEffect } from 'react';
import DataResource from '../../../../common/v4/DataResource'
import Panel from '../../../../common/layout/Panel'
import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel } from './../../../../common/EditPage';
import { getOne, update } from './../../../../common/v4/BackendProvider';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';

const view = (props) => {
    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({});
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { rate_id } = useParams();

    useEffect(() => {
        getOne(`/admin/products/voice/rates/`, rate_id )
            .then(response => {
                setData(response.data.data);
                setLoading(false);
            });
    }, []);

    const handleSave = () => {
        update(`/admin/products/voice/rates/`, rate_id, {data: data})
            .then(response => {
                toast.success('Voice Rate Table updated successfully');
            }).catch(error => {
                toast.error(error.message);
            });
    }

    const handleCancel = () => {
        navigate('/products/voice/rates');
    }

    const onChange = (id, value) => {
        setData({...data, [id]: value});
    }

    const resData = {
            url: `/admin/products/voice/rates/${rate_id}/items`,
            data: {
                data: [],
                metadata: []
            },
            userfilter: [
                {
                    source: 'description',
                    label: 'Description',
                    type: 'text'
                },
                {
                    source: 'prefix',
                    label: 'Prefix',
                    type: 'text'
                },
            ],
            userFilterExpandable: true,
            userFilterSimple: true,
            metadata: [
                {
                    label: 'ID',
                    source: 'id',
                    type: 'primary',
                    visible: false
                },
                {
                    label: 'Prefix',
                    source: 'prefix',
                    type: 'text',
                    placeholder: 'Prefix'
                },
                {
                    label: 'Description',
                    source: 'description',
                    type: 'text',
                    placeholder: 'Description',
                    editable: true,
                },  
                {
                    label: 'Rate',
                    source: 'rate',
                    type: 'text',
                    placeholder: '0.00',
                    default: 0.00,
                    editable: true,
                },  
                {
                    label: 'Connection Fee',
                    source: 'connection_fee',
                    type: 'text',
                    placeholder: '0.00',
                    default: 0.00,
                    editable: true,
                },  
                {
                    label: 'Min Duration',
                    source: 'min_duration',
                    type: 'text',
                    placeholder: '1',
                    default: 1,
                    editable: true,
                },    
                {
                    label: 'Increment',
                    source: 'increment',
                    type: 'text',
                    placeholder: '1',
                    default: 1,
                    editable: true,
                },    
                {
                    label: 'Currency',
                    source: 'currency_id',
                    type: 'select',
                    editable: true,
                },   
                {
                    label: 'Enabled',
                    source: 'enabled',
                    type: 'boolean',
                    default: true,
                    editable: true,
                },
                { 
                    label: 'Deleted',
                    type: 'delete',
                }

            ]
        }

    return (
            <Panel title = {`Voice Rate Table Name: ${data.name}`}>
                <div>
                    <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title={`Update Voice Rate Table: ${data.name}`}>
                        <EditPagePanel>
                            <EditPageTextField label="Name" id="name" onChange={ onChange } value={ data.name } />
                            <EditPageTextField label="Description" id="description" onChange={ onChange } value={ data.description } />
                        </EditPagePanel>
                    </EditPage>
                <DataResource 
                    loading = {loading}
                    data = {resData}
                    {...props}  
                    addButtonText = "Create Item" 
                    addButtonLink = {`/admin/products/voice/rates/${rate_id}/items/new`}/>
                </div>
            </Panel>
        )
    
}

export default view;

